"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Table["default"];
  }
});
var _Table = _interopRequireDefault(require("react-bootstrap/lib/Table"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Table.js
// module id = 1414
// module chunks = 25